// import React, { useEffect, useState } from "react";
// import * as XLSX from "xlsx";
// import { useLoader } from '../../../../context/LoaderProvider.jsx';
// import { fetchAllOrders } from "../../../Servicefile/ordermanagementservice.jsx";
// function CateringPackages() {
//     const [orders, setOrders] = useState([]);
//     const [filteredOrders, setFilteredOrders] = useState([]);
//     const [selectedDate, setSelectedDate] = useState("");
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const { showLoader, hideLoader } = useLoader();

//     useEffect(() => {
//         const getOrders = async () => {
//             setLoading(true);
//             setError(null);

//             try {
//                 showLoader();

//                 const data = await fetchAllOrders();

//                 setOrders(data);

//                 localStorage.setItem(
//                     "ordersData",
//                     JSON.stringify(data)
//                 );
//             } catch (err) {
//                 console.error("Error fetching orders:", err);

//                 setError("Failed to load orders.");

//                 // Load backup data from localStorage
//                 const storedOrders =
//                     localStorage.getItem("ordersData");

//                 if (storedOrders) {
//                     setOrders(JSON.parse(storedOrders));
//                 }
//             } finally {
//                 setLoading(false);
//                 hideLoader();
//             }
//         };

//         getOrders();
//     }, []);


//     // ✅ Filter orders by selected date
//     useEffect(() => {
//         if (!selectedDate) {
//             setFilteredOrders(orders);
//         } else {
//             const filtered = orders.filter((order) => {
//                 if (!order.eventDate) return false;
//                 return order.eventDate.startsWith(selectedDate); // Matches yyyy-mm-dd
//             });
//             setFilteredOrders(filtered);
//         }
//     }, [selectedDate, orders]);

//     // ✅ Export Excel function
//     const exportToExcel = () => {
//         if (filteredOrders.length === 0) {
//             alert("No data to export!");
//             return;
//         }

//         const worksheet = XLSX.utils.json_to_sheet(filteredOrders);
//         const workbook = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(workbook, worksheet, "Catering Orders");
//         XLSX.writeFile(workbook, "CateringOrders.xlsx");
//     };

//     if (loading) return <p>Loading orders...</p>;
//     if (error) return <p style={{ color: "red" }}>{error}</p>;

//     return (
//         <div style={{ fontFamily: "Segoe UI, sans-serif" }}>
//             {/* 🔹 Filter and Export Section */}
//             <div
//                 style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     marginBottom: "15px",
//                     marginTop: "10px",
//                 }}
//             >
//                 <div>

//                     <input
//                         type="date"
//                         value={selectedDate}
//                         onChange={(e) => setSelectedDate(e.target.value)}
//                         style={filterSelectStyle}
//                     />
//                 </div>

//                 <button
//                     onClick={exportToExcel}
//                     style={{
//                         backgroundColor: "rgb(230 109 51)",
//                         color: "#fff",
//                         border: "none",
//                         padding: "8px 16px",
//                         borderRadius: "6px",
//                         cursor: "pointer",
//                         fontWeight: "bold",
//                     }}
//                     onMouseOver={(e) => (e.target.style.backgroundColor = "rgb(230 109 51)")}
//                     onMouseOut={(e) => (e.target.style.backgroundColor = "rgb(230 109 51)")}
//                 >
//                     Export
//                 </button>
//             </div>

//             {/* 🔹 Table Section */}
//             <div
//                 style={{
//                     maxHeight: "420px",
//                     overflowY: "auto",
//                     overflowX: "auto",
//                     border: "1px solid #ddd",
//                     borderRadius: "8px",
//                     scrollbarWidth: "thin",
//                 }}
//             >
//                 <table
//                     style={{
//                         width: "100%",
//                         borderCollapse: "collapse",
//                         marginTop: "5px",
//                         fontSize: "15px",
//                     }}
//                 >
//                     <thead>
//                         <tr
//                             style={{
//                                 backgroundColor: "rgb(230 109 51)",
//                                 color: "white",
//                                 height: "38px",
//                             }}
//                         >
//                             <th style={thStyle}>User ID</th>
//                             <th style={thStyle}>Order ID</th>
//                             <th style={thStyle}>Name</th>
//                             <th style={thStyle}>Email Id</th>
//                             <th style={thStyle}>Mobile Number</th>
//                             <th style={thStyle}>Location</th>
//                             <th style={thStyle}>Event Date</th>
//                             <th style={thStyle}>Event Type</th>
//                             <th style={thStyle}>Veg Plates</th>
//                             <th style={thStyle}>Non-Veg Plates</th>
//                             <th style={thStyle}>Mixed Plates</th>
//                             <th style={thStyle}>Grand Total</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {filteredOrders.length === 0 ? (
//                             <tr>
//                                 <td
//                                     colSpan={12}
//                                     style={{ textAlign: "center", padding: "10px" }}
//                                 >
//                                     No orders found.
//                                 </td>
//                             </tr>
//                         ) : (
//                             filteredOrders.map((item, index) => (
//                                 <tr key={index}>
//                                     <td style={tdStyle}>{item.userId || "N/A"}</td>
//                                     <td style={tdStyle}>Order{item.id || "N/A"}</td>
//                                     <td style={tdStyle}>{item.fullName || "N/A"}</td>
//                                     <td style={tdStyle}>{item.email || "N/A"}</td>
//                                     <td style={tdStyle}>{item.phoneNumber || "N/A"}</td>
//                                     <td style={tdStyle}>{item.city || "N/A"}</td>
//                                     <td style={tdStyle}>
//                                         {item.eventDate
//                                             ? new Date(item.eventDate).toLocaleDateString("en-GB") // "en-GB" → dd/mm/yyyy format
//                                             : "N/A"}
//                                     </td>

//                                     <td style={tdStyle}>{item.eventType || "N/A"}</td>
//                                     <td style={tdStyle}>{item.vegPlates || "N/A"}</td>
//                                     <td style={tdStyle}>{item.nonVegPlates || "N/A"}</td>
//                                     <td style={tdStyle}>{item.mixedPlates || "N/A"}</td>
//                                     <td style={tdStyle}>{item.budget || "N/A"}</td>
//                                 </tr>
//                             ))
//                         )}
//                     </tbody>
//                 </table>
//             </div>
//         </div>
//     );
// }

// // Styles
// const thStyle = {
//     border: "1px solid #ccc",
//     padding: "10px",
//     textAlign: "left",
//     fontWeight: "bold",
// };

// const tdStyle = {
//     border: "1px solid #ccc",
//     padding: "10px",
// };
// const filterSelectStyle = {
//     backgroundColor: "rgb(230 109 51)",
//     color: "#fff",
//     border: "none",
//     height: "35px",
//     borderRadius: "4px",
//     padding: "0 10px",
// };
// export default CateringPackages;





import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { useLoader } from '../../../../context/LoaderProvider.jsx';
import { fetchAllOrders } from "../../../Servicefile/ordermanagementservice.jsx";

// ============================================
// PREMIUM ICONS COMPONENT
// ============================================
const Icons = {
    Export: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
            <polyline points="7 10 12 15 17 10"/>
            <line x1="12" y1="15" x2="12" y2="3"/>
        </svg>
    ),
    Calendar: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
            <line x1="16" y1="2" x2="16" y2="6"/>
            <line x1="8" y1="2" x2="8" y2="6"/>
            <line x1="3" y1="10" x2="21" y2="10"/>
        </svg>
    ),
    User: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
        </svg>
    ),
    Email: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="2" y="4" width="20" height="16" rx="2"/>
            <path d="M22 7l-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
        </svg>
    ),
    Phone: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.362 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.574 2.81.7A2 2 0 0 1 22 16.92z"/>
        </svg>
    ),
    Location: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
            <circle cx="12" cy="10" r="3"/>
        </svg>
    ),
    Veg: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#2e7d32" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <path d="M12 6v6l4 2"/>
        </svg>
    ),
    NonVeg: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#d32f2f" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <line x1="8" y1="8" x2="16" y2="16"/>
            <line x1="16" y1="8" x2="8" y2="16"/>
        </svg>
    ),
    Money: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0b5e42" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <path d="M8 12h8"/>
            <path d="M12 8v8"/>
        </svg>
    ),
    Order: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="2" y="7" width="20" height="14" rx="2" ry="2"/>
            <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
        </svg>
    ),
    NoData: () => (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="1.5">
            <rect x="2" y="3" width="20" height="18" rx="2"/>
            <line x1="8" y1="21" x2="16" y2="21"/>
            <line x1="12" y1="17" x2="12" y2="21"/>
            <path d="M8 7h8M8 11h6M8 15h4"/>
        </svg>
    ),
    Refresh: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M23 4v6h-6M1 20v-6h6"/>
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
        </svg>
    )
};

// ============================================
// PREMIUM STYLES
// ============================================
const styles = {
    container: {
        padding: '1px 5px',
     
        minHeight: '500px'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 0 16px 0',
        borderBottom: '2px solid #e9ecef',
        flexWrap: 'wrap',
        gap: '12px'
    },
    title: {
        fontSize: '20px',
        fontWeight: '600',
        color: '#2d3748',
        letterSpacing: '-0.3px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    titleBadge: {
        background: 'rgb(230 109 51)',
        color: 'white',
        fontSize: '12px',
        fontWeight: '500',
        padding: '2px 12px',
        borderRadius: '12px',
        letterSpacing: '0.3px'
    },
    filtersContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '10px',
        padding: '12px 0',
        borderBottom: '1px solid #edf2f7',
        marginBottom: '16px'
    },
    filterGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        flex: '1 1 auto'
    },
    dateInput: {
        padding: '8px 14px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        fontSize: '13px',
        color: '#2d3748',
        outline: 'none',
        transition: 'all 0.2s ease',
        height: '40px',
        background: 'white',
        minWidth: '160px'
    },
    button: {
        padding: '8px 20px',
        borderRadius: '8px',
        border: 'none',
        fontWeight: '500',
        fontSize: '13px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        height: '40px',
        whiteSpace: 'nowrap'
    },
    buttonPrimary: {
        background: 'rgb(230 109 51)',
        color: 'white'
    },
    buttonSecondary: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    buttonExport: {
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white'
    },
    tableWrapper: {
        borderRadius: '10px',
        border: '1px solid #edf2f7',
        background: 'white',
        overflow: 'auto',
        maxHeight: '500px',
        position: 'relative'
    },
    table: {
        width: '100%',
        fontSize: '13px',
        borderCollapse: 'collapse',
        minWidth: '1200px'
    },
    thead: {
        position: 'sticky',
        top: 0,
        zIndex: 10
    },
    th: {
        padding: '10px 14px',
        textAlign: 'left',
        fontWeight: '600',
        fontSize: '11px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        color: 'white',
        background: 'rgb(230 109 51)',
        borderBottom: '2px solid #d45a1a',
        whiteSpace: 'nowrap'
    },
    td: {
        padding: '10px 14px',
        borderBottom: '1px solid #f1f5f9',
        color: '#2d3748',
        fontSize: '13px',
        verticalAlign: 'middle'
    },
    emptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 20px',
        color: '#a0aec0'
    },
    emptyStateText: {
        marginTop: '16px',
        fontSize: '16px',
        fontWeight: '500',
        color: '#4a5568'
    },
    emptyStateSubtext: {
        fontSize: '13px',
        color: '#a0aec0',
        marginTop: '4px'
    },
    statsBar: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        padding: '8px 0',
        fontSize: '12px',
        color: '#718096',
        flexWrap: 'wrap'
    },
    statItem: {
        display: 'flex',
        alignItems: 'center',
        gap: '4px'
    },
    statNumber: {
        fontWeight: '600',
        color: '#2d3748'
    },
    amount: {
        fontWeight: '700',
        color: '#0b5e42'
    },
    idText: {
        fontFamily: 'monospace',
        fontSize: '12px',
        color: '#4a5568'
    },
    plateBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        padding: '2px 10px',
        borderRadius: '12px',
        fontSize: '12px',
        fontWeight: '600'
    },
    plateVeg: {
        background: '#c6f6d5',
        color: '#276749'
    },
    plateNonVeg: {
        background: '#fed7d7',
        color: '#9b2c2c'
    },
    plateMixed: {
        background: '#bee3f8',
        color: '#2a4365'
    }
};

function CateringPackages() {
    const [orders, setOrders] = useState([]);
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [selectedDate, setSelectedDate] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [isMobile, setIsMobile] = useState(false);
    const { showLoader, hideLoader } = useLoader();

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth < 768);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    useEffect(() => {
        const getOrders = async () => {
            setLoading(true);
            setError(null);

            try {
                showLoader();
                const data = await fetchAllOrders();
                setOrders(data);
                localStorage.setItem("ordersData", JSON.stringify(data));
            } catch (err) {
                console.error("Error fetching orders:", err);
                setError("Failed to load orders.");
                const storedOrders = localStorage.getItem("ordersData");
                if (storedOrders) {
                    setOrders(JSON.parse(storedOrders));
                }
            } finally {
                setLoading(false);
                hideLoader();
            }
        };

        getOrders();
    }, []);

    useEffect(() => {
        if (!selectedDate) {
            setFilteredOrders(orders);
        } else {
            const filtered = orders.filter((order) => {
                if (!order.eventDate) return false;
                return order.eventDate.startsWith(selectedDate);
            });
            setFilteredOrders(filtered);
        }
    }, [selectedDate, orders]);

    const exportToExcel = () => {
        if (filteredOrders.length === 0) {
            alert("No data to export!");
            return;
        }

        const exportData = filteredOrders.map(order => ({
            'User ID': order.userId || 'N/A',
            'Order ID': order.id || 'N/A',
            'Name': order.fullName || 'N/A',
            'Email': order.email || 'N/A',
            'Mobile': order.phoneNumber || 'N/A',
            'Location': order.city || 'N/A',
            'Event Date': order.eventDate ? new Date(order.eventDate).toLocaleDateString('en-GB') : 'N/A',
            'Event Type': order.eventType || 'N/A',
            'Veg Plates': order.vegPlates || 0,
            'Non-Veg Plates': order.nonVegPlates || 0,
            'Mixed Plates': order.mixedPlates || 0,
            'Grand Total': order.budget || 0
        }));

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Catering Orders");
        XLSX.writeFile(workbook, `CateringOrders_${new Date().toISOString().split('T')[0]}.xlsx`);
    };

    const clearDateFilter = () => {
        setSelectedDate("");
    };

    // Calculate stats
    const totalOrders = filteredOrders.length;
    const totalVegPlates = filteredOrders.reduce((sum, order) => sum + (order.vegPlates || 0), 0);
    const totalNonVegPlates = filteredOrders.reduce((sum, order) => sum + (order.nonVegPlates || 0), 0);
    const totalMixedPlates = filteredOrders.reduce((sum, order) => sum + (order.mixedPlates || 0), 0);
    const totalBudget = filteredOrders.reduce((sum, order) => sum + (order.budget || 0), 0);

    if (loading) {
        return (
            <div style={styles.container}>
                <div style={{ textAlign: "center", padding: "40px" }}>
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <p style={{ marginTop: "16px", color: "#718096" }}>Loading catering orders...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div style={styles.container}>
                <div style={{ textAlign: "center", padding: "40px", color: "#fc8181" }}>
                    <div style={{ fontSize: "48px", marginBottom: "16px" }}>⚠️</div>
                    <h3>{error}</h3>
                    <p style={{ color: "#718096" }}>Please try refreshing the page</p>
                </div>
            </div>
        );
    }

    return (
        <div style={styles.container}>
         
            

            {/* Filters */}
            <div style={styles.filtersContainer}>
                <div style={styles.filterGroup}>
                    <Icons.Calendar />
                    <input
                        type="date"
                        value={selectedDate}
                        onChange={(e) => setSelectedDate(e.target.value)}
                        style={styles.dateInput}
                    />
                    {selectedDate && (
                        <button
                            onClick={clearDateFilter}
                            style={{ ...styles.button, ...styles.buttonSecondary }}
                        >
                            Clear
                        </button>
                    )}
                </div>
                <button
                    onClick={exportToExcel}
                    style={{ ...styles.button, ...styles.buttonExport }}
                >
                    <Icons.Export /> Export Excel
                </button>
            </div>

            {/* Table */}
            <div style={styles.tableWrapper}>
                <table style={styles.table}>
                    <thead style={styles.thead}>
                        <tr>
                            <th style={styles.th}>User ID</th>
                            <th style={styles.th}>Order ID</th>
                            <th style={styles.th}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <Icons.User /> Name
                                </div>
                            </th>
                            <th style={styles.th}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <Icons.Email /> Email
                                </div>
                            </th>
                            <th style={styles.th}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <Icons.Phone /> Mobile
                                </div>
                            </th>
                            <th style={styles.th}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <Icons.Location /> Location
                                </div>
                            </th>
                            <th style={styles.th}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <Icons.Calendar /> Event Date
                                </div>
                            </th>
                            <th style={styles.th}>Event Type</th>
                            <th style={{ ...styles.th, textAlign: 'center' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', justifyContent: 'center' }}>
                                    <Icons.Veg /> Veg
                                </div>
                            </th>
                            <th style={{ ...styles.th, textAlign: 'center' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', justifyContent: 'center' }}>
                                    <Icons.NonVeg /> Non-Veg
                                </div>
                            </th>
                            <th style={{ ...styles.th, textAlign: 'center' }}>Mixed</th>
                            <th style={{ ...styles.th, textAlign: 'right' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', justifyContent: 'flex-end' }}>
                                    <Icons.Money /> Grand Total
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredOrders.length === 0 ? (
                            <tr>
                                <td colSpan="12" style={{ padding: 0 }}>
                                    <div style={styles.emptyState}>
                                        <Icons.NoData />
                                        <div style={styles.emptyStateText}>
                                            {orders.length === 0 ? 'No orders found' : 'No orders match the selected date'}
                                        </div>
                                        <div style={styles.emptyStateSubtext}>
                                            {orders.length === 0
                                                ? 'Orders will appear here once they are placed'
                                                : 'Try selecting a different date or clear the filter'}
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        ) : (
                            filteredOrders.map((item, index) => (
                                <tr
                                    key={item.id || index}
                                    style={{
                                        backgroundColor: index % 2 === 0 ? '#ffffff' : '#fafbfc',
                                        transition: 'background 0.15s ease'
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f4ff'}
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : '#fafbfc'}
                                >
                                    <td style={{ ...styles.td, ...styles.idText }}>{item.userId || "N/A"}</td>
                                    <td style={{ ...styles.td, fontWeight: '600', color: 'rgb(230 109 51)' }}>
                                        #{item.id || "N/A"}
                                    </td>
                                    <td style={{ ...styles.td, fontWeight: '500' }}>{item.fullName || "N/A"}</td>
                                    <td style={{ ...styles.td, color: '#4a5568' }}>{item.email || "N/A"}</td>
                                    <td style={styles.td}>{item.phoneNumber || "N/A"}</td>
                                    <td style={styles.td}>{item.city || "N/A"}</td>
                                    <td style={styles.td}>
                                        {item.eventDate
                                            ? new Date(item.eventDate).toLocaleDateString('en-GB')
                                            : "N/A"}
                                    </td>
                                    <td style={styles.td}>
                                        <span style={{
                                            background: '#edf2f7',
                                            padding: '2px 10px',
                                            borderRadius: '4px',
                                            fontSize: '12px',
                                            color: '#4a5568'
                                        }}>
                                            {item.eventType || "N/A"}
                                        </span>
                                    </td>
                                    <td style={{ ...styles.td, textAlign: 'center' }}>
                                        {item.vegPlates > 0 ? (
                                            <span style={{ ...styles.plateBadge, ...styles.plateVeg }}>
                                                <Icons.Veg /> {item.vegPlates}
                                            </span>
                                        ) : (
                                            <span style={{ color: '#a0aec0' }}>—</span>
                                        )}
                                    </td>
                                    <td style={{ ...styles.td, textAlign: 'center' }}>
                                        {item.nonVegPlates > 0 ? (
                                            <span style={{ ...styles.plateBadge, ...styles.plateNonVeg }}>
                                                <Icons.NonVeg /> {item.nonVegPlates}
                                            </span>
                                        ) : (
                                            <span style={{ color: '#a0aec0' }}>—</span>
                                        )}
                                    </td>
                                    <td style={{ ...styles.td, textAlign: 'center' }}>
                                        {item.mixedPlates > 0 ? (
                                            <span style={{ ...styles.plateBadge, ...styles.plateMixed }}>
                                                {item.mixedPlates}
                                            </span>
                                        ) : (
                                            <span style={{ color: '#a0aec0' }}>—</span>
                                        )}
                                    </td>
                                    <td style={{ ...styles.td, textAlign: 'right', ...styles.amount }}>
                                        ₹{item.budget ? parseInt(item.budget).toLocaleString() : "N/A"}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            <style>{`
                @media (max-width: 768px) {
                    .filters-container {
                        flex-direction: column !important;
                        align-items: stretch !important;
                    }
                    
                    .filter-group {
                        flex-wrap: wrap !important;
                    }
                    
                    .date-input {
                        min-width: 120px !important;
                        flex: 1 !important;
                    }
                    
                    .stats-bar {
                        gap: 8px !important;
                        font-size: 11px !important;
                    }
                    
                    .stats-bar span {
                        font-size: 11px !important;
                    }
                }

                @media (max-width: 480px) {
                    .table-container table {
                        font-size: 11px !important;
                    }
                    
                    .table-container table th,
                    .table-container table td {
                        padding: 6px 8px !important;
                        font-size: 10px !important;
                    }
                    
                    .plate-badge {
                        font-size: 10px !important;
                        padding: 1px 6px !important;
                    }
                    
                    .stats-bar {
                        gap: 4px !important;
                    }
                    
                    .stats-bar span {
                        font-size: 10px !important;
                    }
                }

                ::-webkit-scrollbar {
                    width: 6px;
                    height: 6px;
                }
                
                ::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 4px;
                }
                
                ::-webkit-scrollbar-thumb {
                    background: #c1c1c1;
                    border-radius: 4px;
                }
                
                ::-webkit-scrollbar-thumb:hover {
                    background: #a1a1a1;
                }

                .spinner-border {
                    display: inline-block;
                    width: 2rem;
                    height: 2rem;
                    border: 0.25em solid currentColor;
                    border-right-color: transparent;
                    border-radius: 50%;
                    animation: spinner-border 0.75s linear infinite;
                }

                @keyframes spinner-border {
                    to { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
}

export default CateringPackages;
